<template>
    <section id="page-profiel-overzicht" class="page page-profiel-overzicht">
        <div class="page__content">
            <h1>Controleer je gegevens voor het versturen</h1>
            <div class="container">

                <form>
                    <div class="row row--form-item">
                        <div class="col-4-sm">Huidige baan
                        </div>
                        <div class="col-8-sm">
                            <span v-if="userProfile.baan1">
                                {{userProfile.baan1.profileText}} <br/>Gewenst aantal dagen werkzaam: {{getUrenLabel(userProfile.uren1)}}
                            </span>
                            <span v-else>Niet ingevuld!</span>
                        </div>
                    </div>

                    <div class="row row--form-item">
                        <div class="col-4-sm">Gewenste combinatie
                        </div>
                        <div class="col-8-sm">
                            <span v-if="userProfile.baan2">
                                {{userProfile.baan2.label}} <br/>Gewenst aantal dagen werkzaam: {{getUrenLabel(userProfile.uren2)}}
                            </span>
                            <span v-else>Niet ingevuld!</span>
                        </div>
                    </div>

                    <div class="row row--form-item" v-if="userProfile.baan1 && userProfile.baan1.isTeacher===false">
                        <div class="col-4-sm">Lesbevoegdheid
                        </div>
                        <div class="col-8-sm">
                            {{userProfile.bevoegdheid ? 'Ja' : 'Nee'}}
                        </div>
                    </div>

                    <div class="row row--form-item">
                        <div class="col-4-sm">Naam
                        </div>
                        <div class="col-8-sm">
                            {{userProfile.naam}}
                        </div>
                    </div>

                    <div class="row row--form-item">
                        <div class="col-4-sm">E-mailadres
                        </div>
                        <div class="col-8-sm">
                            {{userProfile.email}}
                        </div>
                    </div>

                    <div v-if="userProfile.opMaat && userProfile.opDeHoogteBrengenProjecten">
                        <div class="row row--form-item">
                            <div class="col-4-sm">Woonplaats
                            </div>
                            <div class="col-8-sm">
                                {{userProfile.woonplaats}}
                            </div>
                        </div>

                        <div class="row row--form-item">
                            <div class="col-4-sm">Opleiding
                            </div>
                            <div class="col-8-sm">
                                {{userProfile.opleiding}}
                            </div>
                        </div>

                        <div class="row row--form-item">
                            <div class="col-4-sm">Huidige functie
                            </div>
                            <div class="col-8-sm">
                                {{userProfile.huidigeFunctie}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4-sm">
                        </div>
                        <div class="col-8-sm">
                            <button class="button" v-on:click="submitHandler">Verstuur</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-profiel-overzicht .row--form-item div
        text-align left
        &:first-child
            text-align right
            font-family FranklinGothicDemi

</style>
<script>
    import page from './page';

    export default {
        mixins: [page],
        props: {
            userProfile: {
                type: Object,
                default: {}
            }
        },
        methods: {
            formInputChanged() {
                this.submitAttempt = false;
            },
            getUrenLabel(uren) {
                return uren ? uren : 'Niet ingevuld';
            },
            submitHandler(event) {
                event.preventDefault();
                this.$emit('profileupdate', { key: 'hasSubmitted', value: true });
                this.nextHandler();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// page-profiel-overzicht.vue?16f92dae